export default "__VITE_PUBLIC_ASSET__ca6e875c__"